export default {
  practiceTrain_num_submit:'{submitCount}人提交',
  practiceTrain_ckeck_summary:"點擊每周查看對應的周總結",
  practiceTrain_training_category:'培訓類別:',
  practiceTrain_submit_count:'{submitCount}人已提交',
  practiceTrain_daily_report:'點擊日期查看對應的日報',
  practiceTrain_student:'學員',
  practiceTrain_director:'指導人',
  practiceTrain_instructor:'指導員',
  practiceTrain_rotation:'輪崗',
  practiceTrain_mentor_program:'指導人計劃',
  practiceTrain_action_learn:'行動學習',
  practiceTrain_personal_develop_plan:'個人發展計劃',
  practiceTrain_manager:"主管",
  practiceTrain_director_plan_task: '部門長',
  practiceTrain_train_title01:'試用期工作記錄表',
  practiceTrain_train_title02:'日報（新人每日總結）',
  practiceTrain_train_title03:'周報（新人每周總結）',
  practiceTrain_train_title04:'月報（面談跟蹤記錄表）',
  practiceTrain_train_title05:'指導人評價表',
  practiceTrain_train_fillCard01:'查看指導人安排的階段工作規劃',
  practiceTrain_train_fillCard02:'培訓過程中需填寫日報',
  practiceTrain_train_fillCard03:'培訓過程中需要填寫周報',
  practiceTrain_train_fillCard04:'培訓過程中需要填月報',
  practiceTrain_train_fillCard05:'請填寫對指導人的評價',
  practiceTrain_mentor_title01:'指導人任務清單',
  practiceTrain_mentor_title02:'試用期工作記錄表',
  practiceTrain_mentor_title03:'日報（新人每日總結）',
  practiceTrain_mentor_title04:'周報（新人每周總結）',
  practiceTrain_mentor_title05:'月報（面談跟蹤記錄表）',
  practiceTrain_mentor_title06:'轉正考核表',
  practiceTrain_mentor_fillCard01:'需指導人分階段填報任務完成情況',
  practiceTrain_mentor_fillCard02:'需指導人對學員填寫工作計劃',
  practiceTrain_mentor_fillCard03:'查看學員提交的日報',
  practiceTrain_mentor_fillCard04:'查看學員提交的周報',
  practiceTrain_mentor_fillCard05:'需指導人填寫學員報評價',
  practiceTrain_mentor_fillCard06:'需指導員填寫學員轉正意見',
  practiceTrain_manager_title01:'月報（面談跟蹤記錄表）',
  practiceTrain_manager_fillCard01:'審閱學員提交的月報與指導人意見',
  practiceTrain_director_title01:'月報（面談跟蹤記錄表）',
  practiceTrain_director_title02:'轉正考核表',
  practiceTrain_director_fillCard01:'審閱學員提交的月報與指導人意見',
  practiceTrain_director_fillCard02:'需部門長填寫學員轉正意見',
  practiceTrain_train02_title01:'學員發展計劃表-',
  practiceTrain_train02_title02:'學員發展計劃表-',
  practiceTrain_train02_title03:'學員發展計劃表-',
  practiceTrain_train02_fillCard01:'培訓期間每個階段填報發展計劃與反思',
  practiceTrain_train02_fillCard02:'培訓期間每個階段填報發展計劃與反思',
  practiceTrain_train02_fillCard03:'培訓期間每個階段填報發展計劃與反思',
  mentor02_title01:'學員發展計劃表-',
  mentor02_title02:'學員發展計劃表-',
  mentor02_fillCard01:'需指導人對學員計劃填寫評價',
  mentor02_fillCard02:'需指導人對學員計劃填寫評價',
  manager02_title01:'主管評價表（前測）',
  manager02_title02:'主管評價表（後測）',
  manager02_fillCard01:'需主管在培訓前對學員填寫評價',
  manager02_fillCard03:'需主管在培訓後對學員填寫評價',
  practiceTrain_leave_page01:'評價表（前測）',
  practiceTrain_leave_page02:'評價表（後測）',
  practiceTrain_leave_page03:'階段規劃與反思回顧',
  practiceTrain_leave_page04:'執行整體反思',
  practiceTrain_leave_page05:'規劃',
  practiceTrain_manager_plan_task:"學員發展計劃表-",
  practiceTrain_manager_name:'指導人姓名：',
  practiceTrain_current_evaluable:'當前可評價',
  practiceTrain_currently_review:'當前可審閱',
  practiceTrain_people:"{notAuditCount}人",
  practiceTrain_instructor_comment:'需指導人對學員填寫評價',
  practiceTrain_training_feedback:'培訓項目訓後反饋',
  practiceTrain_month_num:"{monthlyNumber}月",
  practiceTrain_week_num:'第{weeklyNumber}周',
  practiceTrain_week_End:"第{weeklyNumber}周({time})",
  practiceTrain_train_time:"培訓時間: "

}
